<ng-container *ngrxLet="url$ as url">
    <img [src]="url" alt="" [class]="class">
</ng-container>